import { render } from "./ViewVideoBitrateRow.vue?vue&type=template&id=6ba49365&scoped=true"
import script from "./ViewVideoBitrateRow.vue?vue&type=script&lang=js"
export * from "./ViewVideoBitrateRow.vue?vue&type=script&lang=js"

import "./ViewVideoBitrateRow.vue?vue&type=style&index=0&id=6ba49365&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-6ba49365"

export default script